// utils/date.js

/**
 * Formate une Date en YYYY-MM-DD (heure locale)
 * @param {Date} date - Un objet Date valide
 * @returns {string} La date formatée en YYYY-MM-DD
 */
export function formatDateToYYYYMMDD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // mois de 0 à 11
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
